import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axios from "axios";

// [USER_ACTION]: Replace with your real config from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyBvcWon-EMU29CEmpgqaD0v9uZWpa-HZqo",
  authDomain: "nearzon-app.firebaseapp.com",
  projectId: "nearzon-app",
  storageBucket: "nearzon-app.firebasestorage.app",
  messagingSenderId: "674807423720",
  appId: "1:674807423720:web:d3b31bda74fb8868045f5d",
  measurementId: "G-DSP2H9HCLQ"
};

// VAPID Key from Firebase Console -> Project Settings -> Cloud Messaging -> Web Push certificates
const VAPID_KEY = "YOUR_PUBLIC_VAPID_KEY";

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      if (VAPID_KEY === "YOUR_PUBLIC_VAPID_KEY") {
        return null;
      }

      const currentToken = await getToken(messaging, {
        vapidKey: VAPID_KEY,
      });

      if (currentToken) {
        console.log("Web FCM Token:", currentToken);
        // Register with backend
        const user = JSON.parse(localStorage.getItem('user'));
        const token = localStorage.getItem('token');
        
        if (user && token) {
            await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:4000/api'}/users/notifications/register-token`, {
                token: currentToken,
                deviceId: 'web-browser',
                platform: 'web'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
        }
        return currentToken;
      } else {
        console.log("No registration token available. Request permission to generate one.");
      }
    }
  } catch (err) {
    console.log("An error occurred while retrieving token. ", err);
  }
};

export const setupMessageListener = (callback) => {
  onMessage(messaging, (payload) => {
    console.log("Web foreground message:", payload);
    if (callback) {
      callback(payload);
    }
  });
};

export const handleNotificationClick = (payload) => {
  try {
    const data = payload?.data;
    if (!data) return;

    const token = localStorage.getItem('token');
    
    // 1. Unauthenticated Route
    if (!token) {
      if (data.orderId) {
        window.location.href = `/login?redirect=/orders/${data.orderId}`;
      } else {
        window.location.href = `/login?redirect=/notifications`;
      }
      return;
    }

    // 2. Invalid/Fallback Route
    if (!data.type) {
      window.location.href = `/notifications`;
      return;
    }

    // 3. Valid Routing
    switch (data.type) {
      case 'ORDER':
      case 'ORDER_UPDATE':
      case 'PAYMENT':
      case 'DELIVERY':
        if (data.orderId) {
          window.location.href = `/orders/${data.orderId}`;
        } else {
          window.location.href = `/orders`;
        }
        break;
      default:
        window.location.href = `/notifications`;
        break;
    }
  } catch (error) {
    console.error("Error handling notification click:", error);
    window.location.href = `/notifications`;
  }
};

// Global interceptor for service worker messages
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'NOTIFICATION_CLICK') {
      handleNotificationClick(event.data.payload);
    }
  });
}
